import { render, staticRenderFns } from "./editorial-disclosure.vue?vue&type=template&id=0382c5b6&"
import script from "./editorial-disclosure.vue?vue&type=script&lang=js&"
export * from "./editorial-disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports